import React, { FC } from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';
import { useSelector } from 'react-redux';

import TouchableElement from '@components/common/touchableElement';
import { Element, scale } from '@components/frame';

import Svg from '@styles/icons/svg';
import { font } from '@styles/fonts';

import { navigateBack, isWeb } from '@helpers';
import { useManageThumbnailHeaderIcons } from '@v2/components/imageHandling/components/Thumbnail/components/ThumbnailHeader/hooks/useManageThumbnailHeaderIcons';
import { ColorFunction } from '@styles/colors/types';

interface ThumbnailHeaderMobileIconsProps {
  C: ColorFunction;
  scrolled: boolean;
  onBackButtonPress?: () => void;
}

const ThumbnailHeaderMobileIcons: FC<ThumbnailHeaderMobileIconsProps> = (props) => {
  const { C, scrolled, onBackButtonPress } = props;

  const { onAddImagePress } = useManageThumbnailHeaderIcons();

  return (
    <View style={{ width: '100%', height: scale(55) }}>
      <Element
        {...{
          config: {
            position: {
              top: 0,
              left: 8,
            },
            height: 55,
            zIndex: 10000,
          },
        }}
      >
        <TouchableElement onPress={() => (onBackButtonPress ? onBackButtonPress() : navigateBack())}>
          {({ boxStyle, pressHoverColor }) => (
            <View
              style={[
                boxStyle,
                {
                  width: '100%',
                  height: '100%',
                  alignItems: 'center',
                  flexDirection: 'row',
                },
              ]}
            >
              {scrolled && (
                <Svg icon="chevronLeft" width={scale(10)} height={scale(17)} includeScheme={!isWeb} color="Label/Dark/AlwaysLight Primary" />
              )}
              {!scrolled && <Svg icon="chevronLeft" width={scale(10)} height={scale(17)} includeScheme={!isWeb} color="Link / Dark / Primary" />}
              <Text
                style={[
                  font.Body,
                  { color: C(scrolled ? 'Label/Dark/AlwaysLight Primary' : 'Link / Dark / Primary', !isWeb), paddingLeft: scale(8) },
                ]}
              >
                {i18n.t('Back')}
              </Text>
            </View>
          )}
        </TouchableElement>
      </Element>
      <Element
        {...{
          config: {
            position: {
              top: 5,
              right: 6,
            },
            height: 55,
            zIndex: 10000,
          },
        }}
      >
        <TouchableElement onPress={() => onAddImagePress()}>
          {({ boxStyle }) => (
            <View style={{ width: scale(40), height: scale(55) }}>
              <View
                style={[
                  boxStyle,
                  {
                    width: '100%',
                    height: '100%',
                    marginTop: scale(-5),
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                ]}
              >
                {scrolled && <Svg icon="plus" width={scale(16)} height={scale(16)} includeScheme={!isWeb} color="Label/Dark/AlwaysLight Primary" />}
                {!scrolled && <Svg icon="plus" width={scale(16)} height={scale(16)} includeScheme={!isWeb} color="Link / Dark / Primary" />}
              </View>
            </View>
          )}
        </TouchableElement>
      </Element>
    </View>
  );
};

export default ThumbnailHeaderMobileIcons;
